import { supabase } from "@/integrations/supabase/client";
import { ScheduleItem } from "@/components/sleep-schedule/SleepScheduleContext";
import { logger } from "./logger-service";

export class ScheduleRecommendationService {
  static async generateRecommendation(
    childId: string,
    date?: Date
  ): Promise<ScheduleItem[] | null> {
    try {
      const targetDate = date || new Date();
      
      const { data, error } = await supabase.functions.invoke(
        'generate-schedule-recommendation',
        {
          body: {
            child_id: childId,
            date: targetDate.toISOString()
          }
        }
      );

      if (error) {
        logger.error('Error generating schedule recommendation', { error, childId });
        return null;
      }

      if (!data?.schedule) {
        logger.warn('No schedule returned from recommendation service', { childId });
        return null;
      }

      logger.info('Schedule recommendation generated', { 
        childId, 
        itemCount: data.schedule.length,
        context: data.context 
      });

      return data.schedule;
    } catch (error) {
      logger.error('Exception in schedule recommendation service', { error, childId });
      return null;
    }
  }
}
